import { alpha, styled } from '@mui/material';
import Stack from '@mui/material/Stack';

const StyledInner = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),
  padding: theme.spacing(3),
  border: '1px solid',
  borderColor: theme.palette.border.secondary,
  borderRadius: theme.shape.borderRadius * 6,
  backgroundColor: theme.palette.background.primaryAlt,
  ...(theme.palette.mode === 'light' && {
    boxShadow: `0 5px 16px -2.5px ${alpha(theme.palette['Colors/Effects/Shadows/shadow-3xl_02'], 0.06)}`,
  }),
}));

export default StyledInner;
